import { LocalFile } from "@/types";

// 获取文件后缀
export const getExt = (file: File | LocalFile) => {
  return file.name.split(".").pop()?.toLowerCase() || "";
};

// export const sanitizeFileName = (name: string) => {
//   return name.replace(/[^a-zA-Z0-9.\-_]/g, "_");
// };
